import { CarsState } from '../../types';

export const resetSelectedCar = (state: CarsState) => {
  state.selectedEBoxLocation = undefined;
};
